// GetRoutesComponent.js
import { UserContext } from "./services/contexts/UserContext";
import { useEffect, useState, useContext } from "react";
import { RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
import LoginUI from "./pages/Auth/LoginUI";
import GetAppropriateLayout from "./routes/GetAppropriateLayout";
import GetAppropriateRoute from "./routes/GetAppropriateRoute";
import useDecodedUser from "./services/hooks/useDecodedUser";
import { RouterRounded } from "@mui/icons-material";
import UserContextProvider from "./services/contexts/UserContextProvider";

const GetRoutesComponent = () => {
    const [initialView, setInitialView] = useState(null);
    const [router, setRouter] = useState(null);
    const decodedUser = useDecodedUser();
    const { isLoggedIn, user, logout } = useContext(UserContext);
  
    // Effect 1: Set initial layout view ONCE when decodedUser is available
    useEffect(() => {
      if (isLoggedIn) {
        const userId = decodedUser?.id;
        localStorage.setItem("user-id", userId);
        GetAppropriateLayout({ setInitialView, user: decodedUser });
      }
      
    }, []);
  
    // Effect 2: Create router AFTER initial view is set
    useEffect(() => {
      if (decodedUser && initialView && !router) {
        const createdRouter = createBrowserRouter(
          createRoutesFromElements(GetAppropriateRoute({ initialView, decodedUser }))
        );
        setRouter(createdRouter);
        console.log("route:",createdRouter)
      }
      console.log("route:",router)
    }, [decodedUser, initialView, router]);
    // console.log("user",decodedUser, "routing", router)
    if (!decodedUser || !router) return <div>Routing Problem...</div>;
  
    return(
      <UserContextProvider>

        <RouterProvider router={router} />
      </UserContextProvider>)
  };
  
  export default GetRoutesComponent;
//*********************************************************************** */
// // GetRoutesComponent.js
// import { UserContext } from "./services/contexts/UserContext";
// import { useEffect, useState, useContext } from "react";
// import { RouterProvider, createBrowserRouter, createRoutesFromElements } from "react-router-dom";
// import LoginUI from "./pages/Auth/LoginUI";
// import GetAppropriateLayout from "./routes/GetAppropriateLayout";
// import GetAppropriateRoute from "./routes/GetAppropriateRoute";
// import useDecodedUser from "./services/hooks/useDecodedUser";
// import { jwtDecode } from "jwt-decode";

// const GetRoutesComponent = () => {
//     const [initialView, setInitialView] = useState(null);
//     const [router, setRouter] = useState(null);
//     const decodedUser = useDecodedUser();
//     const { isLoggedIn, logout } = useContext(UserContext);

//     console.log("🔍 GetRoutesComponent: decodedUser:", decodedUser);
//     console.log("🔍 GetRoutesComponent: initialView:", initialView);
//     console.log("🔍 GetRoutesComponent: router:", router);
//     console.log("🔍 GetRoutesComponent: isLoggedIn:", isLoggedIn);

//     // Check token validity when component mounts
//     useEffect(() => {
//       const token = sessionStorage.getItem('token');
//       if (token) {
//         try {
//           const decoded = jwtDecode(token);
//           const currentTime = Date.now() / 1000;
//           if (decoded.exp < currentTime && isLoggedIn) {
//             console.log("🔍 GetRoutesComponent: Token expired, logging out...");
//             logout();
//             return;
//           }
//         } catch (error) {
//           console.error("❌ GetRoutesComponent: Error decoding token:", error);
//           if (isLoggedIn) {
//             logout();
//           }
//         }
//       }
//     }, [isLoggedIn, logout]);
  
//     // Effect 1: Set initial layout view ONCE when decodedUser is available
//     useEffect(() => {
//       if (isLoggedIn && decodedUser) {
//         console.log("🔍 GetRoutesComponent: Setting up layout for user:", decodedUser);
//         const userId = decodedUser?.id;
//         sessionStorage.setItem("user-id", userId);
//         GetAppropriateLayout({ setInitialView, user: decodedUser });
//       }
//     }, [isLoggedIn, decodedUser]);
  
//     // Effect 2: Create router AFTER initial view is set
//     useEffect(() => {
//       if (decodedUser && initialView && !router) {
//         console.log("🔍 GetRoutesComponent: Creating router with initialView:", initialView);
//         const createdRouter = createBrowserRouter(
//           createRoutesFromElements(GetAppropriateRoute({ initialView, decodedUser }))
//         );
//         setRouter(createdRouter);
//         console.log("🔍 GetRoutesComponent: Router created successfully");
//       }
//     }, [decodedUser, initialView, router]);

//     // Show loading or redirect if token is invalid
//     const token = sessionStorage.getItem('token');
//     if (isLoggedIn && !token) {
//       console.log("🔍 GetRoutesComponent: No token found but isLoggedIn is true");
//       return <div>Session expired. Redirecting to login...</div>;
//     }
  
//     if (!decodedUser || !router) {
//       console.log("🔍 GetRoutesComponent: Waiting for decodedUser or router. decodedUser:", decodedUser, "router:", router);
//       return <div>Loading application...</div>;
//     }
  
//     console.log("🔍 GetRoutesComponent: Rendering RouterProvider");
//     return <RouterProvider router={router} />;
//   };
  
//   export default GetRoutesComponent;
// //*********************************************************************** */